import { Center, TextLinkButton, getSize, MathEnabledTextComponent, SecondaryButton } from '@lib/common';
import styled from 'styled-components';
import { DeleteOutlined, EditOutlined, MoreOutlined } from '@ant-design/icons';
import { AddMoreSectionPopoverComponent } from '../test-marker-form';
import { Size } from '@module/file-storage';
import { AudioFilePreview, AudioFileContainerDirection } from '../audio-file';
import { StyledLine, StyledSection, StyledSectionWrapper, StyledSpaceContainer, StyledTag } from './section.component';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
var StyledSectionTitleWrapper = styled.div.withConfig({
  displayName: "section-previewcomponent__StyledSectionTitleWrapper",
  componentId: "sc-fevx58-0"
})(["display:flex;justify-content:space-between;align-items:start;min-height:64px;padding:", " ", " ", " ", ";"], getSize('padding8'), getSize('padding0'), getSize('padding16'), getSize('padding0'));
var StyledSectionTitle = styled.div.withConfig({
  displayName: "section-previewcomponent__StyledSectionTitle",
  componentId: "sc-fevx58-1"
})(["font-weight:700;font-size:", ";padding:", ";"], getSize('typo24'), getSize('padding0'));
var StyledDescription = styled(MathEnabledTextComponent).withConfig({
  displayName: "section-previewcomponent__StyledDescription",
  componentId: "sc-fevx58-2"
})(["min-height:40px;padding:", " ", ";white-space:pre-wrap;overflow-wrap:anywhere;img{max-width:100%;}"], getSize('padding16'), getSize('padding0'));
var StyledDeleteButton = styled(TextLinkButton).withConfig({
  displayName: "section-previewcomponent__StyledDeleteButton",
  componentId: "sc-fevx58-3"
})(["margin:", " ", ";"], getSize('padding0'), getSize('padding12'));
var KebabButton = styled(TextLinkButton).withConfig({
  displayName: "section-previewcomponent__KebabButton",
  componentId: "sc-fevx58-4"
})(["width:10px !important;background:'green' !important;"]);
export var SectionPreviewComponent = function SectionPreviewComponent(_ref) {
  var isOnlyRemainingSection = _ref.isOnlyRemainingSection,
      disabled = _ref.disabled,
      onDeleteSection = _ref.onDeleteSection,
      isFocusedSection = _ref.isFocusedSection,
      handleGetPositionElement = _ref.handleGetPositionElement,
      onSelectedSection = _ref.onSelectedSection,
      sectionLabel = _ref.sectionLabel,
      sectionIndex = _ref.sectionIndex,
      hasUnsavedQuestionOrSectionChanges = _ref.hasUnsavedQuestionOrSectionChanges,
      onEditSection = _ref.onEditSection,
      onCreateSection = _ref.onCreateSection,
      section = _ref.section;

  var renderDeleteIcon = function renderDeleteIcon() {
    return !isOnlyRemainingSection && /*#__PURE__*/_jsx(StyledDeleteButton, {
      disabled: disabled,
      onClick: onDeleteSection,
      icon: /*#__PURE__*/_jsx(DeleteOutlined, {
        onClick: function onClick(e) {
          e.stopPropagation();
          onDeleteSection();
        }
      })
    });
  };

  return /*#__PURE__*/_jsx(StyledSpaceContainer, {
    direction: "vertical",
    size: "middle",
    onClick: handleGetPositionElement,
    children: /*#__PURE__*/_jsx(StyledSectionWrapper, {
      children: /*#__PURE__*/_jsxs(StyledSection, {
        $focus: isFocusedSection,
        onClick: function onClick() {
          return onSelectedSection(section.id.toString());
        },
        children: [/*#__PURE__*/_jsx(StyledTag, {
          children: /*#__PURE__*/_jsxs(Center, {
            children: [sectionLabel.section, " ", sectionIndex]
          })
        }), /*#__PURE__*/_jsxs(StyledSectionTitleWrapper, {
          children: [/*#__PURE__*/_jsx(StyledSectionTitle, {
            children: section.title
          }), /*#__PURE__*/_jsx("div", {
            children: !hasUnsavedQuestionOrSectionChanges ? /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(SecondaryButton, {
                icon: /*#__PURE__*/_jsx(EditOutlined, {}),
                onClick: function onClick() {
                  return onEditSection(section.id.toString());
                },
                children: sectionLabel.edit
              }), renderDeleteIcon(), /*#__PURE__*/_jsx(AddMoreSectionPopoverComponent, {
                section: section,
                onCreateSection: onCreateSection,
                labelTranslation: sectionLabel
              })]
            }) : /*#__PURE__*/_jsxs(_Fragment, {
              children: [/*#__PURE__*/_jsx(SecondaryButton, {
                icon: /*#__PURE__*/_jsx(EditOutlined, {}),
                disabled: hasUnsavedQuestionOrSectionChanges,
                onClick: function onClick() {
                  return onEditSection(section.id.toString());
                },
                children: sectionLabel.edit
              }), renderDeleteIcon(), /*#__PURE__*/_jsx(KebabButton, {
                size: "large",
                icon: /*#__PURE__*/_jsx(MoreOutlined, {}),
                type: "text",
                shape: "circle",
                onClick: function onClick(e) {
                  e.stopPropagation();
                }
              })]
            })
          })]
        }), /*#__PURE__*/_jsx(StyledLine, {}), section.audioFile && /*#__PURE__*/_jsx(AudioFilePreview, {
          source: section.audioFile.url,
          fileName: '',
          fileSize: Size.format(section.audioFile.size),
          direction: AudioFileContainerDirection.HORIZONTAL,
          shouldShowExtraInfo: false
        }), /*#__PURE__*/_jsx(StyledDescription, {
          value: section.description
        })]
      })
    })
  });
};